import React, { useState, useEffect, useMemo, useCallback } from "react";
import SelectDropdown from "../../molecules/Dropdown";
import ClientDropdownModal from "../ClientDropdownModal";
import { useSelector } from "react-redux";
import Error from "../../atoms/Error";

const ClientDropdown = ({
  clientOptions = [],
  onClientListChange,
  values,
  setFieldValue,
  isError = false,
  refetchClientList,
  error,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [internalOptions, setInternalOptions] = useState([]);

  const accessData = useSelector((state) => state.accessDetails?.accessData);
  const isAdmin = accessData?.role?.label === "Admin";

  const clientManagementAccess = 
  accessData?.access?.find((module) => module.module === "Client Management") || {};

// Determine if user can edit or delete
 const canEdit = isAdmin || clientManagementAccess?.is_edit;



  // Transform options to match SelectDropdown's expected format
  useEffect(() => {
    const transformedOptions = clientOptions.map((client) => ({
      value: client.value,
      label: client.label || client.name,
    }));
    setInternalOptions(transformedOptions);
  }, [clientOptions,values]);

  const dropdownOptions = useMemo(() => {
    return canEdit
      ? [{ value: "ADD_NEW_CLIENT", label: "+ Add New Client", isAddNew: true }, ...internalOptions]
      : internalOptions;
  }, [canEdit, internalOptions]);

  const handleChange = useCallback((selectedOption) => {
    if (selectedOption?.isAddNew) {
      setIsModalOpen(true);
      return;
    }
    if (selectedOption) {
      setFieldValue("client_id", selectedOption.value);
      const fullClient = clientOptions.find((c) => c.value === selectedOption.value);
      setFieldValue("client_name", fullClient?.name || "");
    } else {
      setFieldValue("client_id", null);
      setFieldValue("client_name", null);
    }
  }, [setFieldValue, clientOptions]);
  
  const onClear = useCallback(() => {
    setFieldValue("client_id", null);
    setFieldValue("client_name", null);
  }, [setFieldValue]);

  const handleAddNewClient = (newClient) => {
    const newOption = {
      value: newClient.value,
      label: newClient.label || newClient.name,
    };

    // Update parent's list and local state
    onClientListChange((prev) => [...prev, newClient]);
    setInternalOptions((prev) => [...prev, newOption]);

    // Update form values
    setFieldValue("client_id", newClient.value);
    setFieldValue("client_name", newClient.name);
  };

  // const handleAddNewClient = (newClient) => {
  //   const newOption = { value: newClient.value, label: newClient.label || newClient.name };
  //   onClientListChange((prev) => [...prev, newClient]); // Updates parent’s client
  //   setFieldValue("client_id", newClient.value);
  //   setFieldValue("client_name", newClient.name);
  // };

  return (
    <>
      <SelectDropdown
        isClearable={true}
        onClear={onClear}
        data={dropdownOptions || []}
        onChange={handleChange}
        selectedValue={values.client_id}
        isError={isError}
        format="all"
      />
      {
        isError && <Error error={error} />
      }
      <ClientDropdownModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleAddNewClient}
        refetchClientList={refetchClientList}
      />
    </>
  );
};

export default ClientDropdown;